import { yup } from '../initYup.ts';

export const WARNING_META_KEY = 'warningMeta';

export function getWarningMeta(meta: any): string | null {
  return meta?.[WARNING_META_KEY] ?? null;
}

export function getWarningMetaFromSchema(
  schema: yup.Schema | null,
): string | null {
  return getWarningMeta(schema?.spec?.meta);
}

declare module 'yup' {
  interface Schema {
    /**
     * Centralizzazione della gestione dei warning. La funzione aggiunge il meta per il messaggio di warning se
     * richiesto.
     */
    warningMeta(message: string): this;
  }
}

function registerForSchema<T extends yup.Schema>(schema: (...arg: any[]) => T) {
  yup.addMethod<T>(schema, 'warningMeta', function (this: T, message: string) {
    return this.meta({ [WARNING_META_KEY]: message });
  });
}

registerForSchema(yup.object);
registerForSchema(yup.array);
registerForSchema(yup.string);
registerForSchema(yup.number);
registerForSchema(yup.boolean);
registerForSchema(yup.date);
registerForSchema(yup.mixed);
